import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import TextField from 'react-mobx-admin/components/common/field/text'
import { LINK_FILMCARGO_HELP } from '../../constants/link_constants'

const _ListView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.FILMCARGO_HELP)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <OptionsField
        attr={attr}
        val={row[attr]}
        options={store.options.get('filmcargo_help_elements')}
        labelattr='label'
        valueattr='value'
        Component={DetailLink} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} textWidth='500px' />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }

  return (
    <ListView store={store.cv} fields={fields} batchActions={batchActions}
      onAddClicked={store.addClicked.bind(store)} helper={store.helpFor(LINK_FILMCARGO_HELP)} />
  )
}
export default observer(_ListView)
